import $http from "../../axios-instance";

/**
 * Listar graficas módulo panel de control.
 * @param payload: company_id, slq_location_id, date_report
 * @autor Paul Valencia
 */
export async function getDataByGraphics({ commit }, payload) {
    try {
        commit("dashboard/load", true, { root: true });

        const response = await $http.get(`panel_control_graphics`, {
            params: payload,
        });
        commit("setInfoGraphics", response.data.data);
        commit("changeShowGraphics", true);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Obtener la data de los cancerígenos.
 *
 * @param payload: company_id, slq_location_id, date_report, in_use
 * return void
 */
export async function getCancerogenicData({ commit }, payload) {
    try {
        commit("dashboard/load", true, { root: true });
        const response = await $http.get(`control-panel/graphic-cancerogenic`, {
            params: payload,
        });
        commit("setCancerogenicData", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Ver detalles de los productos en el histórico de total caracterizados.
 *
 * @param Object commit
 * @param Object {filter, page, perPage}
 * @return void
 */
export async function loadDetailsProductsCharacterized({ commit }, {filter, page, perPage}) {
    commit("dashboard/load", true, { root: true });

    await $http.get(`panel_control_graphics/characterized/details-productos?page=${page}&perPage=${perPage}`, { params: filter })  
        .then(({data: response}) => commit("setProducts", { items: response.data.data, data: response.data}))
        .catch(errors => this.$vue.$alertError(errors.message))
        .finally(() => commit("dashboard/load", false, { root: true }))
}

/**
 * Consultar la información para la gráfica de Toxicidad Acumulada - Por mes en rango de año.
 *
 * @param Object commit
 * @param Object filter
 * @return void
 */
export async function getDataToChartAccumulatedToxicityPerMonthInYearRange({ commit }, filter) {
    commit("dashboard/load", true, { root: true });
    commit("setAccumulatedToxicityGraph", [])

    await $http.get(`control-panel/accumulated-toxicity-graph/per-month-in-the-range-year`, { params: filter })  
        .then(({data: response}) => commit("setAccumulatedToxicityGraph", response.data))
        .catch(errors => this.$vue.$alertError(errors.message))
        .finally(() => commit("dashboard/load", false, { root: true }))
}


/**
 * Consultar la información de los detalles de productos para la gráfica de Toxicidad Acumulada.
 *
 * @param Object commit
 * @param Object filter
 * @return void
 */
export async function getDataToChartAccumulatedToxicityProductsDetails({ commit }, filter) {
    commit("dashboard/load", true, { root: true });
    commit("setAccumulatedProductDetails", null)

    await $http.get(`control-panel/accumulated-toxicity-graph/per-month-in-the-range-year/products-details`, { params: filter })  
        .then(({data: response}) => {

            commit("setAccumulatedProductDetails", {
                phrase: filter.phrase,
                products: response.data
            })

        })
        .catch(errors => this.$vue.$alertError(errors.message))
        .finally(() => commit("dashboard/load", false, { root: true }))
}


/**
 * Consultar la información para la gráfica de Toxicidad aguda.
 *
 * @param Object commit
 * @param Object filter
 * @return void
 */
export async function getDataToChartAcuteToxicity({ commit }, filter) {
    commit("dashboard/load", true, { root: true });
    commit("setAcuteToxicity", [])

    await $http.get(`control-panel/acute-toxicity`, { params: filter })  
        .then(({data: response}) => commit("setAcuteToxicity", response.data))
        .catch(errors => this.$vue.$alertError(errors.message))
        .finally(() => commit("dashboard/load", false, { root: true }))
}

/**
 * Consultar la información de los detalles de productos para la gráfica de Toxicidad aguda.
 *
 * @param Object commit
 * @param Object filter
 * @return void
 */
export async function getDataToChartAcuteToxicityProductsDetails({ commit }, filter) {
    commit("dashboard/load", true, { root: true });
    commit("setAcuteToxicityProductDetails", null)
    commit('setAcuteToxicityShowProductsDetails', true);

    await $http.get(`control-panel/acute-toxicity/products-details`, { params: filter })  
        .then(({data: response}) => commit("setAcuteToxicityProductDetails", response.data))
        .catch(errors => this.$vue.$alertError(errors.message))
        .finally(() => commit("dashboard/load", false, { root: true }))
}

